export * from "-!../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./Richieste.vue?vue&type=template&id=089b6205&"


//////////////////
// WEBPACK FOOTER
// ./modules/Home/views/src/components/Richieste.vue?vue&type=template&id=089b6205&
// module id = 896
// module chunks = 0